// extracted by mini-css-extract-plugin
export default {"includeSolarEnergy":"include-system-card_includeSolarEnergy__oIoCp"};